import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=df56fd90&"
import script from "./DataTable.vue?vue&type=script&lang=ts&"
export * from "./DataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('df56fd90', component.options)
    } else {
      api.reload('df56fd90', component.options)
    }
    module.hot.accept("./DataTable.vue?vue&type=template&id=df56fd90&", function () {
      api.rerender('df56fd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MedioAmbiente/DataTable.vue"
export default component.exports